import { render, staticRenderFns } from "./hospitalSelector.vue?vue&type=template&id=3704db46"
import script from "./hospitalSelector.vue?vue&type=script&lang=js"
export * from "./hospitalSelector.vue?vue&type=script&lang=js"
import style0 from "./hospitalSelector.vue?vue&type=style&index=0&id=3704db46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports